






























































































































































































import { mapState } from "vuex";
import { Component, Prop, Vue } from "vue-property-decorator";
import Auth from "@/components/Auth.vue";
import "@/plugins/googleLogin";
import "@/plugins/facebookLogin";
import formRules from "../helpers/formRules";
import RouteTranslations from "@/locales/routerTranslations";
import {configService, UtilitiesFunctions} from "@/helpers";
import { RootState } from "@/store";
import { User } from "../models/user";

declare const fbq: any;

@Component({
  components: {
    Auth
  },
  computed: {
    ...mapState({
      dialogManager: (state: any) => state.app.dialogManager,
      user: (state: any) => state.session.user
    })
  }
})
export default class AuthComponent extends Vue {
  $refs: any["$refs"] & {
    form: any;
  };
  name = "";
  surname = "";
  userEmail = "";
  password = "";
  confirmPwd = "";
  emailResetPassword: string = "";
  valid = false;
  myRules = {
    name: formRules.nameRules,
    surname: formRules.nameRules,
    email: formRules.mandatoryEmailRules,
    username: formRules.mandatorySelect,
    password: formRules.passwordRules,
    confirmPwd: formRules.confirmPasswordRules
  };
  translations: any = RouteTranslations;
  user!: User;
  hostLogin: boolean = false;
  handleRoute = UtilitiesFunctions.handleRoute;
  googleSignInParams = {
    client_id: configService.googleEnv.clientId
  };
  fbSignInParams = {
    scope: "email",
    return_scopes: true
  };

  @Prop(String) private type!: string;

  get userEmailRules() {
    if (this.type === "signup") {
      return formRules.mandatoryEmailRules;
    }
    return formRules.mandatorySelect;
  }

  mounted() {
    if (this.user) this.emailResetPassword = this.user.email;
    switch (this.type) {
      case "login":
        break;
      case "signup":
        break;
      default:
        break;
    }
  }

  onGoogleSignInSuccess(resp: any) {
    this.resetForm();
    const token = resp.getAuthResponse(true).access_token;
    const user = {
      email: resp.getBasicProfile().getEmail(),
      firstName: resp.getBasicProfile().getGivenName(),
      lastName: resp.getBasicProfile().getFamilyName()
    };
    // After success login with Google,
    // send received token on server and get
    // JWT token
    this.handleSocial(token, user, 'google');
  }

  onFaceBookSignInSuccess(response: any) {
    this.resetForm();
    const token = response.authResponse.accessToken;
    if (response.status === "connected") {
      // @ts-ignore
      FB.api("/me?fields=id,name,first_name,last_name,email", (resp: any) => {
       if(resp.email){
         const user = {
           email: resp.email,
           firstName: resp.first_name ? resp.first_name : resp.name,
           lastName: resp.last_name ? resp.last_name : ""
         };
         // After success login with Facebook,
         // send received token on server and get
         // JWT token
         this.handleSocial(token, user, 'facebook');
       } else {
         this.$store.dispatch("app/setSnackbarMessage", {
           message: `Email permission is required to login with Facebook`,
           color: "red"
         });
       }
      });
    }
  }

  handleSocial(token: string, user: object, provider: string) {
    this.$store
      .dispatch("session/socialAccess", { token, user, provider })
      .then(() => {
        this.closeDialog();
      })
      .catch(error => {
        this.$store.dispatch("session/setLoading", false);
        this.$store.dispatch("app/setSnackbarMessage", {
          message: `Something goes wrong - ${error}`,
          color: "red"
        });
      });
  }

  onSignInError(error: any) {
    this.$store.dispatch("app/setSnackbarMessage", {
      message: `Something goes wrong - ${error}`,
      color: "red"
    });
  }

  handleAuthV2() {
    if (this.type === "login") {
      this.$store
              .dispatch("session/manualLogin", {
                email: this.userEmail,
                password: this.password
              })
              .then((response: Promise<firebase.auth.UserCredential>) => {
                this.closeDialog();
                this.$store.dispatch("session/setLoading", false);
              })
              .catch(error => {
                this.$store.dispatch("session/setLoading", false);
                this.$store.dispatch("app/setSnackbarMessage", {
                  message: this.$t("login.loginError"),
                  color: "red"
                });
                console.error(this.$t("login.loginError"));
              });
    } else {
      this.$store
              .dispatch("session/manualSignup", {
                name: this.name,
                surname: this.surname,
                email: this.userEmail,
                password: this.password
              })
              .then((response: any) => {
                // fbq("track", "CompleteRegistration", {content_name: "manual"});
                this.closeDialog();
                this.$store.dispatch("session/setLoading", false);
              })
              .catch(error => {
                this.$store.dispatch("session/setLoading", false);
                this.$store.dispatch("app/setSnackbarMessage", {
                  message: error.message,
                  color: "red"
                });
                console.error(error);
              });
    }
  }
  //TODO: remove after implement new social registration
  // handleSocial(socialType: string, accessType: string) {
  //   this.resetForm();
  //   this.$store
  //     .dispatch("session/socialAccess", { socialType, accessType })
  //     .then((response: Promise<firebase.auth.UserCredential>) => {
  //       if (accessType === "signUp") {
  //         fbq("track", "CompleteRegistration", { content_name: socialType });
  //       }
  //       this.closeDialog();
  //     })
  //     .catch(error => {
  //       this.$store.dispatch("session/setLoading", false);
  //       this.$store.dispatch("app/setSnackbarMessage", {
  //         message: error,
  //         color: "red"
  //       });
  //       console.error(error);
  //     });
  // }
  handleResetPassword(type: string) {
    this.$store
      .dispatch("session/resetPassword", {email: this.emailResetPassword, type: type})
      .then((success: boolean) => {
        this.closeDialog();
        if (success) {
          this.$store.dispatch("app/setSnackbarMessage", {
            message: "The link for the password change was sent to your email.",
            color: "green"
          });
        } else {
          this.$store.dispatch("app/setSnackbarMessage", {
            message: "Something was wrong, retry later",
            color: "red"
          });
        }
      })
      .catch(error => {
        this.$store.dispatch("session/setLoading", false);
        this.$store.dispatch("app/setSnackbarMessage", {
          message: error,
          color: "red"
        });
        console.error(error);
      });
  }
  pwdMatchError() {
    if (this.password) {
      return this.password === this.confirmPwd
        ? ""
        : this.$t("formRules.pwdMatchError");
    }
  }
  resetForm() {
    this.$refs.form.reset();
  }
  closeDialog() {
    this.$store.dispatch("app/closeDialog", {
      type: null,
      state: false
    });
  }
  handleClick(type: string) {
    this.resetForm();
    this.$store
      .dispatch("app/setDialog", {
        type: type,
        state: true
      })
      .then(() => {})
      .catch(error => {
        console.error(error);
      });
  }

  goToLink(linkUrl: string) {
    this.closeDialog();
    const toRoute = UtilitiesFunctions.handleRoute(linkUrl);
    this.$router.push({ path: `${toRoute}` });
  }
}
